<template>
	<div class="btn-set" :id="uid" :variant="variant">
		<slot name="container">
			<Button
				v-for="(btn, index) in items"
				:key="index"
				:id="`${uid}_${index}`"
				:name="`${uname}_${btn.name || index}`"
				:className="btn.className"
				:iconClassName="btn.iconClassName"
				:iconBeforeLabel="btn.iconBeforeLabel"
				:labelText="btn.labelText"
				:disabled="btn.disabled"
				:btnClick="btn.btnClick"
				:type="btn.type"
			/>
		</slot>
	</div>
</template>
<script>
import Button from '@/components/forms/button/button';

export default {
	name: 'ButtonGroup',
	components: {
		Button
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	}
};
</script>
<style lang="scss" scoped>
.btn-set {
	display: inline-flex;

	> * {
		&:not(:last-child) {
			margin-right: $gutter-md;
		}

		@include mq($until: lg) {
			&:not(:last-child) {
				margin-right: $gutter-lg;
			}
		}
	}

	.btn {
		//at-least 2 small buttons
		&--small:nth-last-child(n + 2),
		&--small:nth-last-child(n + 2) ~ .btn--small {
			@include mq($until: lg) {
				&:not(:last-child) {
					margin-right: $gutter-lg;
				}
			}
		}
	}
}
</style>
